import styled from "styled-components";
import { CLOUDN_COLORS } from "../../../constants/colors";
import { useNavigate } from "react-router-dom";
import { useCallback } from "react";

const PageSelector = (props: { name: string; path: string }) => {
  const nav = useNavigate();

  const onClick = useCallback(() => {
    nav(props.path);
  }, []);
  return <Container onClick={onClick}>{props.name}</Container>;
};

export default PageSelector;

const Container = styled.div`
  width: 45%;
  height: 20%;
  background-color: ${CLOUDN_COLORS.logoBlue};
  border-radius: 10px;
  color: white;
  font-size: 1.5vw;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  &:hover {
    background-color: ${CLOUDN_COLORS.deepNavy};
  }
`;
